import { render, staticRenderFns } from "./CustomInfoCard.vue?vue&type=template&id=67e8c8b2&scoped=true"
import script from "./CustomInfoCard.vue?vue&type=script&lang=js"
export * from "./CustomInfoCard.vue?vue&type=script&lang=js"
import style0 from "./CustomInfoCard.vue?vue&type=style&index=0&id=67e8c8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8c8b2",
  null
  
)

export default component.exports